import { type Address, erc20Abi } from "viem";
import { getClient } from "../lib/client";
import type { ChainId } from "./vault-config";

interface GetErc20BalanceParams {
  chainId: ChainId;
  tokenAddress: Address;
  userAddress: Address;
}

const getErc20Balance = async ({
  chainId,
  tokenAddress,
  userAddress,
}: GetErc20BalanceParams): Promise<bigint> => {
  const client = await getClient(chainId);

  const balance = await client.readContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: "balanceOf",
    args: [userAddress],
  });

  return balance;
};

interface GetErc20DecimalsParams {
  chainId: ChainId;
  tokenAddress: Address;
}
const getErc20Decimals = async ({
  chainId,
  tokenAddress,
}: GetErc20DecimalsParams) => {
  const client = await getClient(chainId);

  const balance = await client.readContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: "decimals",
  });

  return balance;
};

interface GetErc20AllowanceParams {
  chainId: ChainId;
  tokenAddress: Address;
  userAddress: Address;
  spenderAddress: Address;
}

const getErc20Allowance = async ({
  chainId,
  tokenAddress,
  userAddress,
  spenderAddress,
}: GetErc20AllowanceParams) => {
  const client = await getClient(chainId);

  const allowance = await client.readContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: "allowance",
    args: [userAddress, spenderAddress],
  });

  return allowance;
};

const getErc20AllowanceWithDecimals = async ({
  chainId,
  tokenAddress,
  userAddress,
  spenderAddress,
}: GetErc20AllowanceParams) => {
  const client = await getClient(chainId);

  const allowance = await client.multicall({
    contracts: [
      {
        abi: erc20Abi,
        address: tokenAddress,
        functionName: "allowance",
        args: [userAddress, spenderAddress],
      },
      {
        abi: erc20Abi,
        address: tokenAddress,
        functionName: "decimals",
      },
    ],
  });
  return allowance;
};

export {
  getErc20Allowance,
  getErc20AllowanceWithDecimals,
  getErc20Balance,
  getErc20Decimals,
};
